import { FunctionComponent, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import alerticonError from "../../assets/dropdown/alert-icon-error.svg";
import { format, parseISO } from "date-fns";
import { showError } from "./ToastNotification";

interface DateSelectorProps {
    selectedDate: any; // Expecting date as a string
    onChange: (date: string | null) => void; // Date should be handled as string
    // selectedDate: Date | null;
    // onChange: (date: Date | null) => void;
    label?: string;
    error?: any;
    nothideParsedValue?: any;
    blueIcon?: any;
    paddingHandle?: any;
    minDate?: any;
    dontopenDatepicker?: any;
    warningMessage?: any;
    maxDate?: any;
    type?: any;
    showAllDate?: any;
    disabled?: boolean; 
}

const DateSelector: FunctionComponent<DateSelectorProps> = ({
    selectedDate,
    onChange,
    minDate,
    label,
    error,
    nothideParsedValue,
    blueIcon,
    paddingHandle,
    dontopenDatepicker,
    warningMessage,
    maxDate,
    type,
    showAllDate,
    disabled
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [visibleMonth, setVisibleMonth] = useState<Date | null>(null);

    // Ensure selectedDate is a Date object
    // const parsedSelectedDate = selectedDate ? new Date(selectedDate) : null;
    const parsedSelectedDate = selectedDate ? parseISO(selectedDate) : null;

    function handleIconClick(e?: any): void {
        if (disabled) return; // Prevent opening if disabled

        let checkInsideCall = false
        if (e?.target?.className?.length > 0) {
            checkInsideCall = e?.target?.className?.split("__")?.includes('react-datepicker')
        }
        if (!checkInsideCall) {
            if (!dontopenDatepicker) {
                setIsOpen(!isOpen);
                if (!isOpen) {
                    // Set visibleMonth when opening the calendar
                    setVisibleMonth(parsedSelectedDate || new Date());
                }
            } else {
                showError(warningMessage);
            }
        }
    }

    // Function to handle calendar change and update visibleMonth
    function handleCalendarChange(date: Date): void {
        setVisibleMonth(date);
    }

    // Function to handle calendar close
    function handleCalendarClose(): void {
        setIsOpen(false);
    }

    function calculateYearsMonths(date: Date | null): string {
        if (!date) return "";

        const now = new Date();
        let years = now.getFullYear() - date.getFullYear();
        let months = now.getMonth() - date.getMonth();
        let days = now.getDate() - date.getDate();

        if (days < 0) {
            months -= 1;
        }

        if (months < 0) {
            years -= 1;
            months += 12;
        }

        return `${years} years ${months} months`;
    }

    const disableClass = () => {
        return dontopenDatepicker && type === "shift" ? "caretask_calinput" : "";
    };

    return (
        <div
            className={`self-stretch flex-1 inputnew-div flex svg-dark-color flex-col items-start justify-start gap-[8px] text-left text-sm text-text-text-primary font-body-reg `}
        >
            {label && (
                <div className="self-stretch relative font-semibold dark:text-white">
                    {label}
                </div>
            )}
            <div
                className={`${paddingHandle ? paddingHandle : "py-2.5"
                    } cursor-pointer self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] h-[21px] tabelin-input-dv rounded-radius-md bg-text-text-tertiary dark:text-white dark:bg-slate-700 overflow-hidden flex flex-row items-center justify-start px-[15px] border-[1px] border-solid  ${error ? "border-2 border-rose-500 dark:border-rose-500 darkinputborder" : "border-surface-border"
                    } ${disableClass()}`}
                onClick={handleIconClick}
            >
                <div className="min-w-[40%] flex date-emp-input z-8 dateleft-input-dv">
                    <DatePicker
                        placeholderText="mm-dd-yyyy"
                        excludeScrollbar={false}
                        onSelect={handleIconClick}
                        selected={parsedSelectedDate}
                        // onChange={onChange}
                        onChange={(date: any) =>
                            onChange(date ? format(date, "yyyy-MM-dd") : null)
                        } // Convert date to string
                        dateFormat="MM-dd-yyyy"
                        open={isOpen}
                        onClickOutside={handleCalendarClose}
                        popperPlacement="bottom-end"
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={150}
                        showMonthDropdown
                        disabled
                        // onCalendarOpen={() => setVisibleMonth(selectedDate || new Date())} // Set initial visible month
                        onCalendarOpen={() =>
                            setVisibleMonth(parsedSelectedDate || new Date())
                        }
                        onMonthChange={handleCalendarChange} // Update visible month on month change
                        onYearChange={handleCalendarChange}
                        filterDate={(date: Date) => {
                            // Only allow dates from the currently visible month
                            if (!visibleMonth) return true; // allow all dates if visibleMonth is not set
                            if (showAllDate) {
                                return true
                            }
                            if (visibleMonth instanceof Date) {
                                return (
                                    date.getMonth() === visibleMonth.getMonth() &&
                                    date.getFullYear() === visibleMonth.getFullYear()
                                );
                            }
                            return false; // if visibleMonth is not a Date object, filter out all dates
                        }}
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                </div>
                <div className="min-w-[60%] flex gap-[5px] justify-end z-4 dateright-input-dv">
                    <FaCalendarAlt
                        onClick={handleIconClick}
                        className={` ${blueIcon ? "cursor-pointer purple-bg-color" : "text-gray-500"
                            } ml-2`}
                    />
                    {!nothideParsedValue && (
                        <p className="py-0 my-0 text-xs">
                            {calculateYearsMonths(parsedSelectedDate)}
                        </p>
                    )}
                </div>
            </div>
            {error && (
                <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg">
                    <img src={alerticonError} alt="" /> {error}
                </p>
            )}
        </div>
    );
};

export default DateSelector;
